import { Badge, ListGroup } from 'react-bootstrap';
import { FaCheck, FaCheckDouble, FaExclamationTriangle } from 'react-icons/fa';

export default function MensagensList({
  mensagens = [],
  onSelect,
  funcionarios = [],
  onMarcarComoLida,
  abaAtiva = 'recebidas',
}) {
  if (mensagens.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        <p className="mb-0">Nenhuma mensagem encontrada nesta aba.</p>
      </div>
    );
  }

  const getNomeFuncionario = (cod, fallback) => {
    if (fallback) return fallback;
    const f = funcionarios.find((func) => String(func.codFunc) === String(cod));
    return f ? f.nome : cod || 'Desconhecido';
  };

  return (
    <ListGroup variant="flush" style={{ maxHeight: '530px', overflowY: 'auto' }}>
      {mensagens.map((msg) => {
        const isLida = msg.LEITURA === 'S';
        const nomeOrigem = getNomeFuncionario(msg.CODFUNCORIGEM, msg.FO_NOMEFUNC);
        const nomeDestino = getNomeFuncionario(msg.CODFUNCDESTINO, msg.FD_NOMEFUNC);

        return (
          <ListGroup.Item
            key={msg.CODMENSAGEM}
            action
            onClick={() => onSelect(msg)}
            className="d-flex justify-content-between align-items-start p-2 border-bottom"
          >
            <div className="ms-2 me-auto text-truncate" style={{ maxWidth: '78%' }}>
              <div className="fw-bold text-truncate" style={{ fontSize: '0.88rem' }}>
                {abaAtiva === 'todas' && (
                  <span className="text-dark">
                    <strong>De:</strong> {nomeOrigem} ➔ <strong>Para:</strong> {nomeDestino}
                  </span>
                )}
                {abaAtiva === 'recebidas' && <span className="text-dark">De: {nomeOrigem}</span>}
                {abaAtiva === 'enviadas' && (
                  <span className="text-primary">Para: {nomeDestino}</span>
                )}
              </div>

              {msg.NOMEPAC && (
                <small className="d-block text-muted text-truncate fw-semibold">
                  Pac: {msg.NOMEPAC}
                </small>
              )}
            </div>

            <div className="d-flex flex-column align-items-end justify-content-between">
              <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                {msg.DATA_FORMATADA || ''} {msg.HORA || ''}
              </small>

              <div className="d-flex align-items-center gap-1 mt-1">
                {msg.PRIORIDADE === 'ALTA' && (
                  <Badge bg="danger" className="p-1">
                    <FaExclamationTriangle title="Prioridade Alta" />
                  </Badge>
                )}

                {isLida ? (
                  <Badge bg="secondary" className="opacity-75">
                    <FaCheckDouble className="me-1" size={12} /> Lida
                  </Badge>
                ) : (
                  <Badge
                    bg="primary"
                    style={{ cursor: 'pointer' }}
                    title="Clique para marcar como lida"
                    onClick={(e) => {
                      e.stopPropagation();
                      onMarcarComoLida(msg);
                    }}
                  >
                    <FaCheck className="me-1" size={12} /> Marcar como lida
                  </Badge>
                )}
              </div>
            </div>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
}
